export default ({ hrefLang }, { market, t }) => ({
  title: t('meta', 'landing.title'),
  description: t('meta', 'landing.description'),
  canonical: market.domain,
  openGraph: [
    {
      key: 'title',
      content: t('meta', 'company.name'),
    },
    { key: 'type', content: 'website' },
    {
      key: 'image',
      content: `${market.cdn}/g/rfe/logos/logo_v2_symbol.png`,
    },
    { key: 'url', content: market.domain },
  ],
  structuredData: {
    '@context': 'http://schema.org',
    '@type': 'WebSite',
    url: market.domain,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${market.domain}/search?search={search_term}`,
      'query-input': 'required minLength=2 name=search_term',
    },
  },
  android: '/',
  ios: '/',
  hrefLang: Object.keys(hrefLang.start).map(locale => ({
    locale,
    url: hrefLang.start[locale],
  })),
});
